
import axios from "axios";
import moment from 'moment'
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      filtroAvancado: false,
      dataInicial: moment().format('YYYY-MM-DD'),
      dataFinal: moment().format('YYYY-MM-DD'),
      nome: null,
      id: null,
      cpf: null,
      razaoSocial: null,
      registroSelecionadoId: null,
      paginaAtual: 1
      
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    FILTRO_AVANCADO: state => {
        return state.filtroAvancado
    },
    DATA_INICIAL: state => {
        return state.dataInicial
    },
    DATA_FINAL: state => {
        return state.dataFinal
    },
    ID: state => {
        return state.id
    },
    CPF: state => {
        return state.cpf
    },
    NOME: state => {
        return state.nome
    },
    RAZAO_SOCIAL: state => {
        return state.razaoSocial
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    },
    PAGINA_ATUAL: state => {
        return state.paginaAtual
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_FILTRO_AVANCADO: (state, payload) => {
          state.filtroAvancado = payload
      },
      SET_DATA_INICIAL: (state, payload) => {
          state.dataInicial = payload
      },
      SET_DATA_FINAL: (state, payload) => {
          state.dataFinal = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_CPF: (state, payload) => {
          state.cpf = payload
      },
      SET_NOME: (state, payload) => {
          state.nome = payload
      },
      SET_RAZAO_SOCIAL: (state, payload) => {
          state.razaoSocial = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      },
      SET_LIMPAR: (state, payload) => {
        state.lista = []
        state.dataFinal = null
        state.dataInicial = null
        state.id = null
        state.cpf = null
        state.nome = null
        state.razaoSocial = null
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GET_LISTA: ({ commit, getters}, { skipConfirmation = false } = {}) => {
        return new Promise((resolve, reject) => {
          let id = (getters.ID !== null ? getters.ID : '')
          let cpf = (getters.CPF !== null ? getters.CPF : '')
          let nome = (getters.NOME !== null ? getters.NOME : '')
          let razaoSocial = (getters.RAZAO_SOCIAL !== null ? getters.RAZAO_SOCIAL : '')
          
          // Detecta se NOME contém apenas números inteiros (código do cliente)
          if (nome && nome.trim() && /^\d+$/.test(nome.trim())) {
            // Se for apenas números, usa como ID em vez de nome
            id = nome.trim()
            nome = ''
          }
          
          let uri = `api/protected/clientepesquisar?idPesquisa=${id}&cpfPesquisa=${cpf}&nomePesquisa=${nome}&razaSocialPesquisa=${razaoSocial}`
          axios
            .get(uri)
            .then(({ data, status }) => {
              // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
              if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
                // Retorna os dados sem comitar, indicando que precisa de confirmação
                resolve({ 
                  data, 
                  status,
                  needsConfirmation: true,
                  count: data.length
                });
                return
              }
              
              // Carrega os dados normalmente
              commit("SET_LISTA", data);
              if (status === 200 || status === 201) {
                resolve({ data, status, needsConfirmation: false });
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      },
      DELETE_CLIENTE: ({ commit }, clienteId) => {
        return new Promise((resolve, reject) => {
          if (!clienteId) {
            reject(new Error('ID do cliente não informado'))
            return
          }
          
          let uri = `api/protected/cliente/delete/${clienteId}`
          axios
            .post(uri)
            .then(({ data, status }) => {
              if (status === 200 || status === 201) {
                resolve({ data, status })
              }
            })
            .catch(error => {
              reject(error)
            })
        })
      }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/cliente-store.js